import { Type } from 'class-transformer';
import { AddContactInfoRawDto } from './add-contact-info-raw-dto';
import { OwnerRegistrationRawDto } from './owner-registration-raw-dto';

export class RegistrationParameterDto {
  @Type(() => OwnerRegistrationRawDto)
  owner: OwnerRegistrationRawDto;

  @Type(() => AddContactInfoRawDto)
  phoneData: AddContactInfoRawDto;

  @Type(() => AddContactInfoRawDto)
  emailData: AddContactInfoRawDto;
}
